var map = {
	"./completed": 4,
	"./completed.gif": 4,
	"./dtfa-wwk-horizontal-logo-rgb": 5,
	"./dtfa-wwk-horizontal-logo-rgb.jpg": 5,
	"./logo_child-trends": 6,
	"./logo_child-trends.png": 6,
	"./wwk_logo": 7,
	"./wwk_logo.jpg": 7,
	"./wwk_logo_new": 8,
	"./wwk_logo_new.jpg": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;